import { action, observable } from 'mobx';
import { FormField } from '../../components/form-field';
import { ModelMetadata, AchAccountType } from '../../webgiving-generated';
import { createRulesFromMetadata } from '../../validation/validation-rules';

export class AchPaymentMethodViewModel {
	routingNumber: FormField<string>;
	accountNumber: FormField<string>;
	accountType: FormField<AchAccountType>;

	@observable
	accountMismatchError: boolean;

	@observable
	routingNumberFocused: boolean;

	@observable
	accountNumberFocused: boolean;

	constructor() {
		this.routingNumber = new FormField<string>('', createRulesFromMetadata(ModelMetadata.AddACHPaymentMethodRequest.RoutingNumber));
		this.accountNumber = new FormField<string>('', createRulesFromMetadata(ModelMetadata.ConfirmACHAccountRequest.AccountNumber));
		this.accountType = FormField.Unvalidated<AchAccountType>(AchAccountType.Checking);
	}

	@action.bound
	clearValidation() {
		[ this.accountNumber, this.routingNumber, this.accountType ].forEach((field) => field.resetField());
		this.updateAccountMismatchError(false);
	}

	@action.bound
	updateRoutingNumberFocused(focused: boolean) {
		this.routingNumberFocused = focused;
	}

	@action.bound
	updateAccountNumberFocused(focused: boolean) {
		this.accountNumberFocused = focused;
	}

	@action.bound
	updateAccountMismatchError(accountMismatchError: boolean) {
		this.accountMismatchError = accountMismatchError;
	}
}
